var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orders.length
    ? _c("table", { staticClass: "c-orders-list" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          { staticClass: "c-orders-list__body" },
          _vm._l(_vm.orders, function(order) {
            return _c(
              "tr",
              {
                key: order.name,
                staticClass: "c-orders-list__row u-margin-bottom-x-small"
              },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "c-orders-list__cell c-orders-list__cell--order-number l-grid l-grid--no-gap l-grid--2-col-fixed"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9"
                      },
                      [_vm._v("Order:")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "t-link c-orders-list__cell-link l-grid__item--justify-end",
                        attrs: { href: order.url }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(order.name) + "\n        "
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9"
                      },
                      [_vm._v("Date:")]
                    ),
                    _vm._v("\n        " + _vm._s(order.date) + "\n      ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9"
                      },
                      [_vm._v("Payment Status:")]
                    ),
                    _vm._v(
                      "\n        " + _vm._s(order.financialStatus) + "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9"
                      },
                      [_vm._v("Fulfillment Status:")]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(order.fulfillmentStatus) +
                        "\n      "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "c-orders-list__cell l-grid l-grid--no-gap l-grid--2-col-fixed"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "c-orders-list__mobile-label u-text-align-left l-grid__item--justify-start t-heading-9"
                      },
                      [_vm._v("Total:")]
                    ),
                    _vm._v("\n        " + _vm._s(order.total) + "\n      ")
                  ]
                )
              ]
            )
          }),
          0
        )
      ])
    : _c("p", { staticClass: "u-text-align-center" }, [
        _c("strong", [_vm._v("You haven't placed any orders yet.")])
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "c-orders-list__head" }, [
      _c("tr", { staticClass: "c-orders-list__row c-orders-list__row" }, [
        _c(
          "th",
          {
            staticClass: "c-orders-list__heading t-heading-6",
            attrs: { scope: "col" }
          },
          [_vm._v("\n        Order\n      ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "c-orders-list__heading t-heading-6",
            attrs: { scope: "col" }
          },
          [_vm._v("\n        Date\n      ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "c-orders-list__heading t-heading-6",
            attrs: { scope: "col" }
          },
          [_vm._v("\n        Payment Status\n      ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "c-orders-list__heading t-heading-6",
            attrs: { scope: "col" }
          },
          [_vm._v("\n        Fulfillment Status\n      ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "c-orders-list__heading t-heading-6",
            attrs: { scope: "col" }
          },
          [_vm._v("\n        Total\n      ")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }